var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState } from 'react';
import Icon from "../Icon";
import { ButtonDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

var DropdownButton = function DropdownButton(_ref) {
  var children = _ref.children,
      color = _ref.color,
      direction = _ref.direction,
      title = _ref.title,
      icon = _ref.icon,
      iconSize = _ref.iconSize;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDropdownOpen = _useState2[0],
      setIsDropdownOpen = _useState2[1];

  var toggle = function toggle() {
    return setIsDropdownOpen(function (isDropdownOpen) {
      return !isDropdownOpen;
    });
  };

  return React.createElement(
    ButtonDropdown,
    {
      isOpen: isDropdownOpen,
      toggle: toggle,

      direction: direction
    },
    React.createElement(
      DropdownToggle,
      { color: color },
      title,
      icon && React.createElement(Icon, { icon: icon, size: iconSize })
    ),
    React.createElement(
      DropdownMenu,
      null,
      children
    )
  );
};

export default DropdownButton;